import React, {useContext, useEffect, useState} from 'react';
import {
  ScrollView,
  StyleSheet,
  KeyboardAvoidingView,
  Platform,
  View,
  Keyboard,
} from 'react-native';
import {SafeAreaView, useSafeAreaInsets} from 'react-native-safe-area-context';
import {BottomTabBarHeightContext} from '@react-navigation/bottom-tabs';
import TopHeader from './TopHeader';
import {colors} from '../config/theme';

const ScreenWrapper = ({
  children,
  isBackButton,
  Heading,
  onBack,
  refreshControl,
}) => {
  const insets = useSafeAreaInsets();
  // Undefined outside the tab navigator. Inside it the tab bar already pads
  // the system nav area; outside it (auth stack) Android 15+ edge-to-edge
  // would otherwise draw content under the navigation bar.
  const inTabs = useContext(BottomTabBarHeightContext) !== undefined;
  const [keyboardVisible, setKeyboardVisible] = useState(false);

  useEffect(() => {
    const show = Keyboard.addListener('keyboardDidShow', () =>
      setKeyboardVisible(true),
    );
    const hide = Keyboard.addListener('keyboardDidHide', () =>
      setKeyboardVisible(false),
    );
    return () => {
      show.remove();
      hide.remove();
    };
  }, []);
  return (
    <SafeAreaView style={styles.safeArea} edges={['top']}>
      <TopHeader
        isBackButton={isBackButton}
        Heading={Heading}
        onBack={onBack}
      />
      <View style={styles.contentWrapper}>
        <KeyboardAvoidingView
          style={styles.flex1}
          behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
          keyboardVerticalOffset={Platform.OS === 'ios' ? 60 : 0}>
          <ScrollView
            style={styles.scrollView}
            contentContainerStyle={[
              styles.scrollContent,
              {paddingBottom: keyboardVisible || !inTabs ? insets.bottom : 0},
            ]}
            keyboardShouldPersistTaps="handled"
            refreshControl={refreshControl}>
            {children}
          </ScrollView>
        </KeyboardAvoidingView>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: colors.background,
  },
  scrollView: {
    flex: 1,
    backgroundColor: colors.background,
  },
  scrollContent: {
    flexGrow: 1,
  },
  flex1: {
    flex: 1,
  },
  contentWrapper: {
    flex: 1,
    backgroundColor: colors.background,
  },
});

export default ScreenWrapper;
